import React from 'react'

import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import LogoutIcon from '@material-ui/icons/ExitToApp'
import SettingsIcon from '@material-ui/icons/Settings'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as Model from 'api/model'

const styles = theme => ({
  root: {},
  configEditorButton: {
    marginTop: 10,
    marginLeft: 6,
    textTransform: 'none',
    fontWeight: 'normal'
  },
  settingsIcon: {
    color: '#7b7b7b',
    marginRight: 8
  }
})

class ToolsPanelUtils extends React.Component {
  componentDidMount () {
    const eToolsPanelUtils = document.getElementById('tools-panel-utils')
    eToolsPanelUtils.style.display = 'initial'
  }

  generateConfigManagerLink () {
    const sitename = Model.get('app.site')
    const location = window.location

    // Add 'enterprise[true]' if we're viewing the enterprise version and we're in staging or dev mode
    const { enterprise, environment } = window.getAppInfo()
    const enterpriseFragment = (enterprise && environment !== 'production') ? '/enterprise[true]' : ''

    const link = `${location.origin}${location.pathname}#/site[${sitename}]/config[true]${enterpriseFragment}/preview[true]/`

    return link
  }

  msalLogout () {
    window.signOut()
  }

  render () {
    const { classes } = this.props

    // Show a logout button only if we are enterprise and the user is logged in
    const appInfo = window.getAppInfo()
    const isEnterprise = !!appInfo.enterprise
    const msalUser = isEnterprise && window.msalInstance?.getAllAccounts?.()?.[0]

    return (
      <React.Fragment>
        {msalUser &&
        <Button className={classes.configEditorButton} startIcon={<LogoutIcon className={classes.settingsIcon} />} onClick={this.msalLogout} title={`Log out user ${msalUser.username}`}>
          Log out of Microsoft Single Sign-On
        </Button>
        }

        <Button className={classes.configEditorButton} startIcon={<SettingsIcon className={classes.settingsIcon} />} href={this.generateConfigManagerLink()} target="_blank">
          Administrator Login
        </Button>
      </React.Fragment>
    )
  }
}

ToolsPanelUtils.propTypes = {
  classes: PropTypes.object.isRequired
}

function mapStateToProps (state, ownProps) {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ToolsPanelUtils)
  )
)
